import { AssignStatus, InclusionFilterStatus, PriorityFilterStatus } from "@/enum/list.enum";
import { GetUnassignedListRequestPaginationParams } from "@/pages/Private/pages/List/schema/list";

export type BuilderPreviewInput = Pick<
	GetUnassignedListRequestPaginationParams,
	"page" | "limit" | "sorting" | "listId" | "filter"
> & { query?: string };

/** Every lead stage the campaign builder's lead panel shows, from draft to ended. */
const BUILDER_PREVIEW_ASSIGN_STATUSES = [
	AssignStatus.DRAFT,
	AssignStatus.SAVED_FOR_LATER,
	AssignStatus.ASSIGNED,
	AssignStatus.RUNNING,
	AssignStatus.MESSAGE_SENT,
	AssignStatus.DONE,
	AssignStatus.ENDED,
];

/**
 * The campaign builder's lead-panel request (`list/unassigned-and-dummy`), extracted from
 * CampaignPage. The page passes the same object to `clearInbox`, which makes it the panel's active
 * scope, and to the query, so only this request's answer may fill the panel (PREC-4790 r1).
 */
export const buildBuilderPreviewRequest = ({
	page,
	limit,
	query,
	sorting,
	listId,
	filter,
}: BuilderPreviewInput): GetUnassignedListRequestPaginationParams => ({
	page,
	limit,
	searchValue: query,
	sorting,
	assignStatus: BUILDER_PREVIEW_ASSIGN_STATUSES,
	listId,
	filter,
	inclusionFilterStatus: [InclusionFilterStatus.ADDED],
	priorityFilterStatus: [PriorityFilterStatus.ALL],
});
